
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { GetDeviceByIdAndTypeParameters, GetDeviceByKey } from './types';
import { DeviceWithAssetAndRadioData } from '../entities/device-radios-v2/device-with-asset-and-radio-data-response';
import { axiosInstance } from "../axios-instance";

class Devices {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getByIdAndType(
    input: GetDeviceByIdAndTypeParameters,
  ): Promise<AxiosResponse<DeviceWithAssetAndRadioData>> {
    const { id, ...queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceWithAssetAndRadioData>(`${this.baseUrl}/devices/deviceIds/${id}`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getByKey(input: GetDeviceByKey): Promise<AxiosResponse<DeviceWithAssetAndRadioData>> {
    const { deviceKey, ...queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceWithAssetAndRadioData>(
      `${this.baseUrl}/devices/deviceKeys/${deviceKey}`,
      {
        params: queryParameters,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  getByRadioSerialNumber(radioSerialNumber: string) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceWithAssetAndRadioData>(
      `${this.baseUrl}/devices/radioSerialNumbers/${radioSerialNumber}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  getByDeviceSerialNumber(deviceSerialNumber: string) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceWithAssetAndRadioData>(
      `${this.baseUrl}/devices/deviceSerialNumbers/${deviceSerialNumber}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  bulkGetByDeviceSerialNumber(deviceSerialNumber: string) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<DeviceWithAssetAndRadioData[]>(
      `${this.baseUrl}/devices/bulkGetByDeviceSerialNumber?showDisabled=true`,
      [
        {
          deviceSerialNumber,
        },
      ],
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  bulkGetByDeviceId(input: { deviceId: string; deviceType?: string }) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<DeviceWithAssetAndRadioData[]>(
      `${this.baseUrl}/devices/bulkGetByDeviceId?showDisabled=true&assetEnrichment=true`,
      [input],
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  bulkGetByDeviceKey(deviceKey: string | string[]) {
    const accessToken = localStorage.getItem('accessToken');
    let input: any = deviceKey
    if(typeof deviceKey === 'string') {
      input = [{deviceKey}];
    }
    return axiosInstance.post<DeviceWithAssetAndRadioData[]>(
      `${this.baseUrl}/devices/bulkGetByDeviceKey?showDisabled=true`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  getCheckIns(key: string) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceWithAssetAndRadioData>(`${this.baseUrl}/deviceKeys/${key}/checkIns`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  updateDeviceRadio(deviceKey: string, payload: any) {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<DeviceWithAssetAndRadioData>(
      `${this.baseUrl}/devices/${deviceKey}/radio`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}

export default Devices;
